//import Libraries
import React from 'react';

//import Components

//import Styles
import './Contact.css'

const contact = ({contact, checked, handleOnChange, index}) => {

    const {date, name, message, mail} = contact;

    return (
            <tr>
                <th>
                    <input type="checkbox" name={`${index}`} checked={checked} onChange={handleOnChange} />
                </th>
                <td>{name}</td>
                <td>{mail}</td>
                <td>{date}</td>
                <td>{message}</td>
            </tr>
    );
}

export default contact;


// WEBPACK FOOTER //
// ./src/pages/Admin/ContactManager/Contact.js